import React from 'react';
import { sitesUrls } from "§/src/utils/sitesUrls";

const SchemaProductCategoryChild = ({ subCat, catProducts }) => {
  const currentLang = process.env.GATSBY_SITE_LANG;
  const siteInfo = sitesUrls(currentLang);

  // Function to remove HTML tags and handle null/undefined values
  const removeHtmlTags = (str) => {
    if (str == null) return ''; // Return empty string if null or undefined
    return str.replace(/<[^>]*>/g, '');
  };

  // Filter out EOP products and sort remaining products
  const filteredAndSortedProducts = catProducts
    .filter(product => product.acf.badge !== 'eop')
    .sort((a, b) => {
      if (a.acf.badge === 'phase_out' && b.acf.badge !== 'phase_out') {
        return 1; // Move phase_out products to the end
      } else if (a.acf.badge !== 'phase_out' && b.acf.badge === 'phase_out') {
        return -1; // Keep non-phase_out products at the beginning
      }
      return a.menuOrder - b.menuOrder; // Sort by menuOrder
    });

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "numberOfItems": filteredAndSortedProducts.length,
    "description": removeHtmlTags(subCat.description),
    "name": subCat.name,
    "itemListElement": filteredAndSortedProducts.map((product, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "url": `${siteInfo.url}${product.uri}`
    }))
  };

  return (
    <script type="application/ld+json">
      {JSON.stringify(schemaData)}
    </script>
  );
};

export default SchemaProductCategoryChild;
